import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule } from '../../../shared/angular-calendar';
import { CalendarHeaderComponent } from './calendar-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    // NgbDatepickerModule.forRoot(),
    // NgbTimepickerModule.forRoot(),
    CalendarModule
  ],
  declarations: [
    CalendarHeaderComponent
  ],
  exports: [
    CalendarHeaderComponent
    // DateTimePickerComponent
  ]
})
export class DemoUtilsModule {}


// WEBPACK FOOTER //
// ./src/app/appointments/dashboard/demo-utils/module.ts